import React from "react";
import Signin from "Pages/Signin";

const Signintheme = () => {
  return (
    <React.Fragment>
      <Signin />
    </React.Fragment>
  );
};

export default Signintheme;
